import { Injectable, NgZone } from '@angular/core';
import PouchDB from 'pouchdb';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of, BehaviorSubject, combineLatest, pipe } from 'rxjs';
import { Menu, Order, OrderStatus, OrderItem, User, Restaurant, MsgTypes, MessageClientRest, CrypDoc, langsWithFullTranslation, allLang, Lang, Time, TableInfo, RestaurantOpenHours, Colors } from '../models';
// import * as dbt from 'src/app/tools-db';
import * as cfg from 'src/config.json';
// import { randSafeGen } from "src/app/tools";
import { AuthService } from '../auth/auth.service';
import { CryptoService } from './crypto.service';
import { DbToolsService } from './db-tools.service';
import { LogService } from './log.service';
import { EventSourcePolyfill } from 'event-source-polyfill';
import { distinctUntilChanged, map, pairwise, startWith } from 'rxjs/operators';
import { Title } from '@angular/platform-browser';
import { create } from 'domain';
import { SwUpdate } from '@angular/service-worker';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DataClientService {
  private config = cfg.default.client;
  // private subs: any[] = [];
  private subsDict: {} = {};
  user$: BehaviorSubject<User> = new BehaviorSubject(new User());
  dbCurrentRestaurant: any;
  currentRestaurant: Restaurant = new Restaurant();
  currentOrder$: BehaviorSubject<Order> = new BehaviorSubject(new Order());
  currentMenu$: BehaviorSubject<Menu> = new BehaviorSubject(new Menu());
  ordersInLocalUserDB$ = this.auth.ordersInLocalUserDB$;
  private restaurantPubKey: JsonWebKey;

  public activeRestId$: BehaviorSubject<{ rId: string, tableId: string }> = new BehaviorSubject({ rId: '', tableId: '' });
  public eventSourceErrors: string[] = ['eventsource log:'];
  public publicDbEventSource: EventSource;

  public syncedPublicDocs$: BehaviorSubject<{ rId: string, docs: string[] }> = new BehaviorSubject({ rId: '', docs: [] });

  public clientLang$: BehaviorSubject<string> = new BehaviorSubject('');

  public currentRestaurantMenuLangs$: BehaviorSubject<Lang[]> = new BehaviorSubject([]);

  public isRestaurantOpen$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  appColors = cfg.default['defaultAppColors'];
  appColors$: BehaviorSubject<Colors> = new BehaviorSubject(this.appColors);
  priorityFieldHidden$: BehaviorSubject<Boolean> = new BehaviorSubject(cfg.default['priorityFieldHidden']);
  // let sections = this.menu$.getValue().sections.map((s,i) => {return {idx:i,content:s.name,type:'section'}})
  // let menuItems = this.menu$.getValue().sections.reduce((t,c,i) => [...t, ...c.items.map((p,j)=> {return {sidx:i,idx:j,content:[p.name,...(p.variant ? p.variant:[]),...(p.ingr ? p.ingr:[])].join(', '),type:'menuItem'}})],[])


  // OLD SHIT ---------------->
  // dbLocalName = 'local';
  // dbLocal: any = new PouchDB(this.dbLocalName);
  // dbRemote: any = false;
  // dbSync: any = false;
  // // remoteHost: string = "35.211.134.62:5984/"
  // remoteHost = 'localhost:5984/';
  // remoteProtocol = 'http://';
  // adderUrl = 'http://35.211.134.62:5984/';

  // dbLocOrdersPublic: any = new PouchDB('orders-public');
  // dbRemOrdersPublic: any = new PouchDB(`${this.remoteProtocol}${this.remoteHost}/orders-public`);
  // <--------------------------


  constructor(
    private http: HttpClient,
    private auth: AuthService,
    private cryp: CryptoService,
    private zone: NgZone,
    private dbt: DbToolsService,
    private log: LogService,
    private title: Title,
    private updates: SwUpdate
  ) {

    this.activeRestId$.pipe(
      pairwise()
    ).subscribe({
      next: async ([p, n]) => {
        if (p.rId === n.rId && p.tableId === n.tableId) { return; };
        if (p.rId !== n.rId) {
          await this.changeRestaurant(n.rId);
        };
        if (p.tableId !== n.tableId && n.tableId !== '') {
          await this.changeTable(n.rId, n.tableId);
        };
      }
    });

    this.currentOrder$.pipe(
      map(o => o._id),
      pairwise()
    ).subscribe({
      next: async ([p, n]) => {
        // save draft of order
        if (n === null && this.currentOrder$.getValue().restId != undefined) {
          localStorage.setItem(`tempOrder-${this.currentOrder$.getValue().restId}`, JSON.stringify(this.currentOrder$.getValue()))
        }
        else { localStorage.removeItem(`tempOrder-${this.currentOrder$.getValue().restId}`) };
        if (p === n) { return; };
        await this.changeOrder(n);
      }
    })

    this.syncedPublicDocs$.pipe(
      pairwise()
    ).subscribe({
      next: async ([p, n]) => {
        if (JSON.stringify(p) === JSON.stringify(n)) { return; };
        await this.changeSyncDocsFromPublicDb(n.docs);
      }
    })


    this.auth.online$.pipe(
      pairwise()
    ).subscribe({
      next: async ([p, n]) => {
        // console.warn(p),
        // console.warn(n)
        if (!p && n) {
          // console.warn('offline -> online')
          await this.changeOrder();
          await this.getMenu();
          await this.changeSyncDocsFromPublicDb(this.syncedPublicDocs$.getValue().docs);
        }
      }
    })

    this.currentMenu$.subscribe({
      next: menu => {
        if (menu._id != null) {
          this.isRestaurantOpen();
          this.auth.menuLoaded$.next(true);
          // add info about menu revision
          const temp = this.currentOrder$.getValue();
          temp.menuRev = menu._rev;
          temp.lang = menu.lang//this.getCurrentMenuLanguage();
          this.currentOrder$.next(temp);
          // check app version
          if (menu.appVer !== undefined) {
            if (this.dbt.compareAppVer(this.log.msgs[0], menu.appVer) == 1) {
              //update ?
              setTimeout(async () => {
                await this.updates.checkForUpdate();
              }, 10000);
            }
          }
          // create search object
          this.auth.updateSearchCollection(menu);
        } else {
          this.auth.menuLoaded$.next(false);
        }
      }
    });

    this.clientLang$.pipe(
      startWith(''),//this.auth.appLang),
      distinctUntilChanged()
    ).subscribe({
      next: async lang => {
        if (lang === '') { return; };
        localStorage.setItem('lang',lang);
        if (langsWithFullTranslation.map(l => l.code).includes(lang) && lang !== this.auth.appLang) {
          if (environment.local) {
            // simulate auth.service
            this.auth.appLang = lang;
            this.auth.clientLang = lang;
            await this.getMenu({ lang })
            return;
          } else {
            if (this.publicDbEventSource !== undefined) {
              this.publicDbEventSource.close(); // stop syncing previous menu
            };            
            let url = location.origin;
            let pathArr = location.pathname.split('/');
            pathArr[1] = lang;
            window.location.href = url + pathArr.join('/');// + `?l=${lang}`;
            return;
          };
        }
        await this.getMenu({ lang });
        return;
        // }
      }
    })

  }

  async changeRestaurant(rId: string) {
    this.currentMenu$.next(new Menu());
    await this.refreshRestData2(rId);
    this.currentRestaurantMenuLangs$.next(await this.getAvailableMenuLangs());
    const restLangCodes = this.currentRestaurantMenuLangs$.getValue().map(l => l.code);
    if (restLangCodes.includes(this.auth.clientLang)) {
      // if menu available in user browsers language
      this.clientLang$.next(this.auth.clientLang);
    } else {
      this.clientLang$.next(restLangCodes.includes('en') ? 'en' : restLangCodes[0]);
    };
  }

  // getCurrentMenuLanguage(): string {
  //   return this.currentMenu$.getValue()._id?.split(':')[1] || this.clientLang$.getValue();
  // };

  async changeTable(rId: string, tableId: string, lang: string = this.clientLang$.getValue()) {
    const temp: Order = this.currentOrder$.value;
    temp.restId = rId;
    temp.tableId = tableId;
    temp.lang = lang;
    temp.restName = this.currentRestaurant.name ? this.currentRestaurant.name : rId;
    this.currentOrder$.next(temp);
  }

  async changeOrder(oId: string = this.currentOrder$.getValue()._id) {
    if (oId == null) { return; };
    let remoteOrder = await this.http.get(`${this.config.couchRemoteURL}/${this.currentRestaurant.id}-public/${oId}`).toPromise() as any;
    if (remoteOrder === 'not_found') {
      remoteOrder = (await this.dbt.getDocById(oId, this.auth.dbUserLocal)) as Order;
      if (
        remoteOrder.status !== OrderStatus.ready ||
        remoteOrder.status !== OrderStatus.delivered ||
        remoteOrder.status !== OrderStatus.rejected) {
        remoteOrder.status = OrderStatus.rejected;
      };
      this.currentOrder$.next(new Order(remoteOrder));
    } else {
      await this.updateOrderByRest(remoteOrder as Order);
      await this.auth.refreshLocalOrders();
    };

    this.syncedPublicDocs$.next({ rId: this.currentRestaurant.id, docs: [this.currentMenu$.getValue()._id, oId] });
  }
  async changeSyncDocsFromPublicDb(docs: string[]) {

    if (this.publicDbEventSource !== undefined) {
      this.publicDbEventSource.close();
    }

    const url = `${this.config.couchRemoteURL}/${this.currentRestaurant.id}-public/_changes?feed=eventsource&filter=_doc_ids&doc_ids=${JSON.stringify(docs)}&since=now&include_docs=true&heartbeat=30000`;
    // this.eventSourceErrors.push(url);
    this.publicDbEventSource = new EventSource(url);

    this.publicDbEventSource.onopen = async (e: Event) => { await this.publicDbOpenHandler(e) };
    this.publicDbEventSource.onmessage = async (m: MessageEvent) => { await this.publicDbMessageHandler(m) };
    this.publicDbEventSource.onerror = async (e: Event) => { await this.publicDbErrorHandler(e) };

  }

  /**
   * Get menu live using event-source
   * https://docs.couchdb.org/en/stable/api/database/changes.html#event-source
   * https://github.com/Yaffle/EventSource/
   * 
   * @param restId 
   * @param lang 
   */
  async getMenu({ restId = this.currentRestaurant.id, lang = this.clientLang$.getValue() } = { restId: this.currentRestaurant.id, lang: this.clientLang$.getValue() }) {
    // console.debug(`getMenu: ${restId}, ${lang}`)
    if (restId == null) { return; };
    let menu = await this.http.get(`${this.config.couchRemoteURL}/${restId}-public/menu:${lang}`).toPromise() as Menu;
    this.currentMenu$.next(new Menu(menu));

    if (this.currentOrder$.getValue()._id !== null) {
      this.syncedPublicDocs$.next({ rId: this.currentRestaurant.id, docs: [`menu:${lang}`, this.currentOrder$.getValue()._id] });
    } else {
      this.syncedPublicDocs$.next({ rId: this.currentRestaurant.id, docs: [`menu:${lang}`] });
    }

  }

  async getAvailableMenuLangs(restId = this.currentRestaurant.id): Promise<Lang[]> {
    return (await this.dbt.getDocByIdPrefixWithHttp(
      'menu',
      `${this.config.couchRemoteURL}/${restId}-public`,
      false
    ) as { rows: { id: string }[] }).rows
      .map(r => {
        return allLang.filter(l => l.code == r.id.split(':')[1])[0];
      })
      .sort((a, b) => a.name > b.name ? 1 : -1);
  }

  async publicDbMessageHandler(m: MessageEvent) {
    const doc = (JSON.parse(m.data)).doc;
    if (doc?.type == "menu") {
      this.zone.run(() => this.currentMenu$.next(new Menu(doc)));
      return;
    };
    if (doc.ord !== undefined && doc.encSymKey !== undefined) {
      await this.updateOrderByRest(doc);
      return;
    };
    // console.warn(m); 
  }

  async publicDbErrorHandler(e: Event) {
    this.eventSourceErrors.push(`${this.publicDbEventSource.readyState}`);// - ${JSON.stringify(e,[...Object.keys((e as any).__proto__),...Object.keys(e)],1)}`);
    setTimeout(async () => {
      await this.changeOrder();
      await this.getMenu();
      await this.changeSyncDocsFromPublicDb(this.syncedPublicDocs$.getValue().docs);
    }, 5000 + Math.floor(Math.random() * 10000));
  }

  async publicDbOpenHandler(e: Event) {
    this.eventSourceErrors.push(`${this.publicDbEventSource.readyState}`);// - ${JSON.stringify(e,[...Object.keys((e as any).__proto__),...Object.keys(e)],1)}`)
  }

  // async closeSyncsDict(): Promise<void> {
  //   for (let sync in this.subsDict) { await this.dbt.cancelSync(this.subsDict[sync]); delete this.subsDict[sync]; }
  // }

  async refreshRestData2(restId: string) {
    let crypFile = await this.http.get(`${this.config.couchRemoteURL}/${restId}-public/cryp`).toPromise() as CrypDoc;
    this.currentRestaurant.id = restId;
    this.currentRestaurant.name = crypFile.fullName ? crypFile.fullName : restId;
    this.currentRestaurant.info = crypFile.info;
    this.restaurantPubKey = crypFile.ckey;
    this.title.setTitle(`look@menu in ${this.currentRestaurant.name}`);
    const appColors = crypFile.appColors ?? cfg.default.defaultAppColors;
    this.appColors$.next(appColors);
    this.priorityFieldHidden$.next(crypFile.priorityFieldHidden ?? cfg.default.priorityFieldHidden);
  }

  changeOrderLang(m: Menu) {
    const order: Order = this.currentOrder$.value;
    order.lang = m.lang;
    order.items.forEach(i => {
      for (const s of m.sections) {
        for (const mi of s.items) {
          if (i.ref.split(':')[0] === mi._id.split(':')[0]) {
            i.ref = mi._id;
            i.name = mi.name;
            i.variant ? i.variant.name = mi.variant[i.variant.idx] : {}
          }
        }
      }

    });
    this.currentOrder$.next(order)
  }

  // addBasicOrderInfo(restId: string, tableId: string, lang: string, restName?: string) {
  //   const temp: Order = this.currentOrder$.value;
  //   temp.restId = restId;
  //   temp.tableId = tableId;
  //   temp.lang = lang;
  //   temp.restName = restName ? restName : restId
  //   this.currentOrder$.next(temp);
  // }

  // async createOrder(ord: Order = this.currentOrder$.value): Promise<any> {

  //   if (!ord._id) { ord._id = `o:${ord.tableId}:${Date.now()}:${this.dbt.randSafeGen(3)}` };

  //   delete ord._rev;
  //   // await this.auth.checkLoggedUser(); // TODO check if necessary
  //   if (this.auth.loggedUser$.value.login) {
  //     ord.madeBy = this.auth.loggedUser$.value.login;
  //   } else {
  //     ord.madeBy = this.auth.loggedUser$.value.guest.login;
  //   }
  //   // this.log.log(JSON.stringify(this.auth.loggedUser$.value))
  //   // this.log.log(this.auth.loggedUser$.value)
  //   // this.log.log(ord.madeBy)
  //   // save to remote db
  //   let symKey

  //   if (ord.symKey.key !== '' && ord.symKey.iv !== '') {
  //     symKey = await this.cryp.importKeyIv(ord.symKey);
  //   } else {
  //     symKey = await this.cryp.getKeyIvAESGCM();
  //     ord.symKey = await this.cryp.exportKeyIv(symKey);
  //   }
  //   // if offline during order creation
  //   let restPubKey = this.restaurantPubKey ? this.restaurantPubKey : (await this.getRestaurantPublicKey()) as JsonWebKey;
  //   if (!restPubKey) { return false; }
  //   this.restaurantPubKey = restPubKey;
  //   const encSymKey = await this.cryp.encryptRSAOAEP(ord.symKey, this.restaurantPubKey);
  //   const encOrd = await this.cryp.encryptAESGCM(ord, symKey);
  //   let resp: any;
  //   if (ord.revRemote) {
  //     resp = await this.dbt.createDoc({ ord: encOrd, encSymKey, _rev: ord.revRemote, user: ord.madeBy }, this.dbCurrentRestaurant, ord._id);
  //   } else {
  //     resp = await this.dbt.createDoc({ ord: encOrd, encSymKey, user: ord.madeBy }, this.dbCurrentRestaurant, ord._id);
  //   }
  //   // this.log.log(resp)
  //   if (!resp) {
  //     // this.log.log(resp)
  //     return false;
  //   }

  //   // save to user base
  //   ord.revRemote = resp.rev;
  //   const resp2 = await this.dbt.createDoc(ord, this.auth.dbUserLocal, ord._id); // TODO: add suport for incognito mode (indexeddb not working)
  //   // this.log.log(resp2)
  //   this.currentOrder$.next(ord);
  //   return true;
  // }

  async createOrder2(ord: Order = this.currentOrder$.value): Promise<any> {

    if (!ord._id) { ord._id = `o:${ord.tableId}:${Date.now()}:${this.dbt.randSafeGen(3)}` };

    delete ord._rev;
    if (this.auth.loggedUser$.value.login) {
      ord.madeBy = this.auth.loggedUser$.value.login;
    } else {
      ord.madeBy = this.auth.loggedUser$.value.guest.login;
    }
    let symKey

    if (ord.symKey.key !== '' && ord.symKey.iv !== '') {
      symKey = await this.cryp.importKeyIv(ord.symKey);
    } else {
      symKey = await this.cryp.getKeyIvAESGCM();
      ord.symKey = await this.cryp.exportKeyIv(symKey);
    }
    // if offline during order creation
    let restPubKey = this.restaurantPubKey ? this.restaurantPubKey : (await this.getRestaurantPublicKey()) as JsonWebKey;
    if (!restPubKey) { return false; }
    this.restaurantPubKey = restPubKey;
    const encSymKey = await this.cryp.encryptRSAOAEP(ord.symKey, this.restaurantPubKey);
    const encOrd = await this.cryp.encryptAESGCM(ord, symKey);
    let body: any;
    if (ord.revRemote) {
      body = { _id: ord._id, ord: encOrd, encSymKey, _rev: ord.revRemote, user: ord.madeBy }
      // resp = await this.dbt.createDoc({ ord: encOrd, encSymKey, _rev: ord.revRemote, user: ord.madeBy }, this.dbCurrentRestaurant, ord._id);
    } else {
      body = { _id: ord._id, ord: encOrd, encSymKey, user: ord.madeBy }
      // resp = await this.dbt.createDoc({ ord: encOrd, encSymKey, user: ord.madeBy }, this.dbCurrentRestaurant, ord._id);
    }
    const token = await this.auth.getProperToken('jwt:user');
    const options = {
      withCredentials: false,
      headers: {
        Authorization: `Bearer ${token.JWT}`
      }
    };
    const resp = await this.http.post(`${this.config.couchRemoteURL}/${this.currentRestaurant.id}-public`, body, options).toPromise() as any;
    // this.log.log(resp)
    if (!resp) {
      // this.log.log(resp)
      return false;
    }
    // console.warn(resp)
    // save to user base
    ord.revRemote = resp.rev;
    const resp2 = await this.auth.dbUserLocal.put(ord);
    this.currentOrder$.next(ord);
    return true;
  }

  async updateOrderByClient2(ord: Order = this.currentOrder$.value): Promise<any> {
    this.auth.connectClient(); // TODO should not be necessary!!!
    if (!ord._id) {
      const orderCreated = await this.createOrder2(ord);
      if (!orderCreated) { return false }
      return await this.logOrder();
    }
    // update remote copy
    const restPubKeyTemp = this.restaurantPubKey ? this.restaurantPubKey : (await this.getRestaurantPublicKey()) as JsonWebKey;
    if (!restPubKeyTemp) { return false; }
    const restPubKey = restPubKeyTemp;

    const symKey = await this.cryp.importKeyIv(ord.symKey);
    const encSymKey = await this.cryp.encryptRSAOAEP(ord.symKey, restPubKey);
    const encOrd = await this.cryp.encryptAESGCM(ord, symKey);
    // const resp = await this.dbt.createDoc({ ord: encOrd, encSymKey, _rev: ord.revRemote, user: ord.madeBy }, this.dbCurrentRestaurant, ord._id);
    const body = { _id: ord._id, ord: encOrd, encSymKey, _rev: ord.revRemote, user: ord.madeBy };
    const token = await this.auth.getProperToken('jwt:user');
    const options = {
      withCredentials: false,
      headers: {
        Authorization: `Bearer ${token.JWT}`
      }
    };
    const resp = await this.http.post(`${this.config.couchRemoteURL}/${this.currentRestaurant.id}-public`, body, options).toPromise();

    if (!resp) { return false; };
    this.currentOrder$.next(ord);
    return true;
  }

  async logOrder(ord: Order = this.currentOrder$.value): Promise<any> {
    const logOrderUrl = `${this.config.logOrder}`;
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    const ordToLog = JSON.parse(JSON.stringify(ord))
    if ('_rev_tree' in ordToLog) { delete ordToLog['_rev_tree']; };
    if ('symKey' in ordToLog) { delete ordToLog['symKey']; };
    const body = {
      ord: ordToLog,
    }

    const data = JSON.stringify(body);
    try {
      const logCreated = await this.http.post(logOrderUrl, data, { headers }).toPromise();
      this.log.log(logCreated);
    } catch (error) {
      this.log.log(error);
      return false;
    }

    return true
  }

  async getRestaurantPublicKey(): Promise<JsonWebKey | boolean> {
    let restPubKey;
    try {
      // restPubKey = (await this.dbt.getDocById('cryp', this.dbCurrentRestaurant)).ckey;
      restPubKey = (await this.http.get(`${this.config.couchRemoteURL}/${this.currentRestaurant.id}-public/cryp`).toPromise() as CrypDoc).ckey;
    } catch (error) {
      restPubKey = false;
    }
    return restPubKey;
  }

  async updateOrderByRest(doc) {
    // if (!this.auth.dbUserLocal) { await this.connectDbs(); }
    this.auth.connectClient(); // TODO should not be necessary!!!
    if (doc._deleted) { return; }
    const id = doc._id;
    const revRemote = doc._rev;
    const res = await this.dbt.getDocById(id, this.auth.dbUserLocal);
    if (res === 'not_found') {
      this.log.log('order not in local user db');
      return
    }
    const oldOrder: Order = new Order(res);

    if (oldOrder.revRemote === revRemote) {
      this.zone.run(() => this.currentOrder$.next(oldOrder));
      return;
    }

    const symKeyString = oldOrder.symKey;
    const symKey = await this.cryp.importKeyIv(symKeyString);
    const remoteOrder: Order = new Order(await this.cryp.decryptAESGCM(doc.ord, symKey));

    if (oldOrder.revRemote !== revRemote) {
      remoteOrder._rev = oldOrder._rev;
      remoteOrder.revRemote = revRemote;
      await this.dbt.updateDoc(remoteOrder, this.auth.dbUserLocal);
    };
    this.zone.run(() => this.currentOrder$.next(remoteOrder));
    return;
  }

  async callService(ord: Order = this.currentOrder$.value) {

    const callMsg = new MessageClientRest({ type: MsgTypes.call_service_req, content: '', time: Date.now() });

    const newOrd: Order | false = this.addMessageToRest(callMsg, ord);
    if (newOrd) {
      await this.updateOrderByClient2(newOrd);
    }
    return;
  }

  addMessageToRest(msg: MessageClientRest, ord: Order = this.currentOrder$.value): Order | false {
    if (ord.msgToRest.filter((v) =>
      v.type === msg.type &&
      v.content === msg.content &&
      v.time > msg.time - this.config.minimalTimeBetweenCalls).length > 0) {
      this.log.log('repeated order')
      return false;
    } else {
      ord.msgToRest.push(msg);
      this.currentOrder$.next(ord);
    }
    return ord;
  }

  async sendMessageToRest(msg: MessageClientRest, ord: Order = this.currentOrder$.value): Promise<any> {
    const newOrd = this.addMessageToRest(msg, ord);
    if (newOrd) {
      await this.updateOrderByClient2(newOrd);
    }
  }

  async deleteOrder(ord: any, db: any = this.auth.dbUserLocal): Promise<any> {
    try {
      await this.dbt.deleteByIdDocSafe(ord._id, db)
      await this.auth.refreshLocalOrders()
    } catch (err) {
      this.log.log("deleteOrder client: " + err)
    }
  }

  /**
   * @description generates time stamps for possible pick up time stamps
   * @param start 
   * @param end 
   * @returns 
   */
  getTimeStamps(start: Time = new Time(0,0), end: Time = new Time(23,59), minimumWaitingTime: Time = new Time(0,15), defaultTimeStep: number = 15): string[] | false {
    const timeStamps: string[] = [$localize`jak najszybciej`];
    let td: number;
    const temp = new Date();
    const now: Time = new Time(temp.getHours(), temp.getMinutes());
    // const now = new Time(17,0)
    const firstPossible = now.add(minimumWaitingTime);
    if (this.timeDelta(start, end) > 0) { // eg. 8:00 - 16:00
      if (this.timeDelta(start, firstPossible) < 0 || this.timeDelta(firstPossible, end) < 0) {
        return false;
      }
      td = Math.floor(this.timeDelta(firstPossible, end) / defaultTimeStep);
    } else { // eg. 19:00 - 2:00
      if (this.timeDelta(start, firstPossible) < 0 && this.timeDelta(firstPossible, end) < 0) {
        return false;
      };
      td = Math.floor(this.timeDelta(firstPossible, new Time(end.hours + (firstPossible.hours < end.hours ? 0 : 24), end.minutes)) / defaultTimeStep);
    };
    for (let i = 1; i <= td; i++) {
      const hours = (firstPossible.hours + Math.floor((firstPossible.minutes + i * defaultTimeStep) / 60)) % 24;
      const minutes = (firstPossible.minutes + i * defaultTimeStep) % 60;
      const timeStamp = new Time(hours, minutes)
      timeStamps.push($localize`${(timeStamp).toString()} (+${minimumWaitingTime.hours * 60 + minimumWaitingTime.minutes + i * defaultTimeStep} minut)`);
    }
    return td == 0 ? false : timeStamps;
  };

  /**
   * @description Compare Time objects
   * @param first 
   * @param second 
   * @returns time diff between first and second in minuts (positive -> first before second)
   */
  timeDelta(first: Time, second: Time): number {
    return (second.hours - first.hours) * 60 + (second.minutes - first.minutes)
  }

  /**
   * Update current order (this.currentOrder$)
   * @param newValues dict of values to update
   * @returns if ok, true, if error, nothing (raise error)
   */
  updateLocalCurrentOrder(newValues: {}): boolean {
    const temp = this.currentOrder$.getValue();
    for (const key of Object.keys(newValues)) {
      temp[key] = newValues[key];
    };
    this.currentOrder$.next(temp);
    return true;
  };

  getPickUpTime() {
    return this.currentOrder$.getValue().pickUpTime.split('(')[0]
  }

  getRestTables(): TableInfo[] {
    const tabs: TableInfo[] = 'tablesInfo' in this.currentMenu$.getValue() ? this.currentMenu$.getValue().tablesInfo.tables : [];
    if (tabs.length == 0 || tabs[0].tableId !== 'notab') {
      tabs.unshift({tableId:'notab', tableName: this.getTableName('notab')})
    };    
    return tabs
  }
  getOpenHours(): { openTime: Time, closeTime: Time, minimumWaitingTime: Time } {
    const oH = 'openHours' in this.currentMenu$.getValue() ? this.currentMenu$.getValue().openHours : new RestaurantOpenHours();
    const now = new Date();
    const nowInMinutes = now.getHours() * 60 + now.getMinutes();
    let today = now.getDay();
    const todayOpenInMinutes = oH.openHours[today].openTime.hours * 60 + oH.openHours[today].openTime.minutes;
    const yesterdayOpenInMinutes = oH.openHours[today > 0 ? today - 1 : 6].openTime.hours * 60 + oH.openHours[today > 0 ? today - 1 : 6].openTime.minutes;
    const yesterdayCloseInMinutes = oH.openHours[today > 0 ? today - 1 : 6].closeTime.hours * 60 + oH.openHours[today > 0 ? today - 1 : 6].closeTime.minutes;
    if (yesterdayCloseInMinutes < yesterdayOpenInMinutes && nowInMinutes < todayOpenInMinutes && nowInMinutes < yesterdayCloseInMinutes) {
      today = today > 0 ? today - 1 : 6
    }
    return { openTime: oH.openHours[today].openTime, closeTime: oH.openHours[today].closeTime, minimumWaitingTime: oH.minimumWaitingTime }
  };

  getTableName(tableId: string): string {
    const tn = this.currentMenu$.getValue().tablesInfo?.tables.filter((t: TableInfo) => t.tableId == tableId)[0]?.tableName
    return tn ? tn : tableId == 'notab' ? $localize `odbiór osobisty` : tableId;
  }

  isRestaurantOpen(): void {
    const oH: { openTime, closeTime, minimumWaitingTime } = this.getOpenHours();
    const ts = this.getTimeStamps(oH.openTime, oH.closeTime, oH.minimumWaitingTime);
    this.isRestaurantOpen$.next(!!ts);
  }
  // ================================================================





  // async getMenuOnce(id: string): Promise<Menu> {
  //   this.curRest = new PouchDB(`${this.remoteProtocol}${this.remoteHost}/${id}-public`);
  //   try {
  //     const menu = await this.curRest.get('menu');
  //     return menu.menu;
  //   } catch (error) {
  //     this.log.log(error);
  //   }
  // }







  // async getOrderFromRemoteById(restId: string, orderId: string) {
  //   this.currentRestaurant = new PouchDB(`${this.remoteProtocol}${this.remoteHost}/${restId}-public`);
  //   try {
  //     const order = await this.currentRestaurant.get(orderId);
  //     return order;
  //   } catch (error) {
  //     this.log.log(error);
  //   }
  // }









  // oldest shit
  // ordersPublicAll(): void {
  //   const oPubAllsync = PouchDB.sync(
  //     this.dbRemOrdersPublic,
  //     this.dbLocOrdersPublic, {
  //     live: true,
  //     retry: true
  //   }
  //   );
  // }

  // ordersPublicClient(): void {
  //   const oPubAllsync = PouchDB.sync(
  //     this.dbRemOrdersPublic,
  //     this.dbLocOrdersPublic, {
  //     live: true,
  //     retry: true,
  //     // filter: (d) => d.type === '1',
  //     since: 'now',
  //     filter: 'orders/getByT',
  //     query_params: { type: 1 }
  //   }
  //   );
  // }


  // async logoutRestRoot(): Promise<boolean> {
  //   if (this.dbSync) {
  //     this.dbSync.cancel();
  //   }

  //   try {
  //     await this.dbLocal.destroy();
  //   } catch (err) {
  //     this.log.log(err);
  //     return false;
  //   }
  //   this.dbLocal = new PouchDB(this.dbLocalName);
  //   // because of: https://stackoverflow.com/questions/26111362/cant-re-create-pouchdb-database-with-same-name
  //   this.log.log('logged out');
  //   return true;
  // }

  // connectLocalDb(): any {
  //   return this.dbLocal.changes({ live: true, filter: (d) => this.changesFilter(d) });
  // }

  // changesFilter(doc): boolean {
  //   // only existed docs
  //   return !doc._deleted;
  // }

  // async saveDoc(doc): Promise<boolean> {
  //   try {
  //     const oldDoc = await this.dbLocal.get(doc._id); // for update
  //     doc._rev = oldDoc._rev;
  //   } catch (error) { }
  //   try {
  //     const res = await this.dbLocal.put(doc);
  //     // this.log.log(res)
  //   } catch (err) {
  //     this.log.log(err);
  //     return false;
  //   }
  //   return true;
  // }


  // addSomething(): void {
  //   const newAdd = { added: Math.random() };
  //   this.dbLocal.post(newAdd).then((r) => this.log.log(r)).catch((e) => this.log.log(e));
  // }

  // async getAllOnce(): Promise<any> {
  //   let docs: any = [];
  //   try {
  //     docs = await this.dbLocal.allDocs({ include_docs: true });
  //   } catch (error) {
  //     this.log.log('no local db');
  //   }
  //   return docs;
  // }



  // randSafeGen(n: number = 5): string {
  //   let rand = '';
  //   // https://www.ietf.org/rfc/rfc3986.txt
  //   const urlSafes = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'; // -._~'
  //   const getChar = () => urlSafes[Math.floor(Math.random() * urlSafes.length)];
  //   for (let i = 0; i < n; i++) {
  //     rand += getChar();
  //   }
  //   // return rand
  //   return 'test01';
  // }

  // getUserDatabaseName(user: string): string {
  //   return 'userdb-' + user.split('')
  //     .map(c => c.charCodeAt(0).toString(16))
  //     .join('');
  // }

}
